// Integração Google Ads (gtag.js) — carregada UMA única vez nas páginas públicas.
// Consent Mode negado por padrão: sem cookies de publicidade antes de consentimento
// e sem envio de dados pessoais ou de saúde. Configuração vem do painel (Integrações).
let adsConfig = null;
let tagLoaded = false;
let listenerReady = false;

export function initGoogleAds(config) {
  adsConfig = config || null;
  const tag = adsConfig?.enabled ? adsConfig?.tag_id : "";
  if (tag && !tagLoaded) {
    tagLoaded = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag("consent", "default", {
      ad_storage: "denied",
      analytics_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      wait_for_update: 500,
    });
    window.gtag("js", new Date());
    window.gtag("config", tag, { allow_ad_personalization_signals: false, ads_data_redaction: true });
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(tag)}`;
    document.head.appendChild(s);
  }
  if (!listenerReady) {
    listenerReady = true;
    // Estrutura de medição: qualquer clique em link wa.me aciona a conversão,
    // mas o evento SÓ é enviado quando identificador + rótulo estiverem configurados.
    document.addEventListener("click", (e) => {
      if (e.target.closest && e.target.closest('a[href*="wa.me"]')) trackWaConversion();
    });
  }
}

export function trackWaConversion() {
  const sendTo = adsConfig?.conversion_send_to;
  if (!sendTo || typeof window.gtag !== "function") return;
  window.gtag("event", "conversion", { send_to: sendTo });
}
